import React from 'react'

const IconPlusSquare = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.25 21.5V18.25M20.25 18.25V15M20.25 18.25H17M20.25 18.25H23.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5"></path>
            <path d="M2.13435 8.72083L7.50768 21.6667C7.6659 22.0605 7.9358 22.3996 8.28417 22.6421C8.63254 22.8846 9.0442 23.02 9.46851 23.0317C9.75018 23.0317 10.0427 22.9775 10.3243 22.8583L18.3085 19.5542C19.121 19.2183 19.6193 18.4167 19.641 17.615C19.6518 17.3333 19.5977 17.0192 19.5002 16.7375L14.0835 3.79167C13.9309 3.39485 13.6621 3.05331 13.3123 2.81171C12.9624 2.57011 12.5478 2.43969 12.1227 2.4375C11.841 2.4375 11.5593 2.5025 11.2885 2.6L3.31518 5.90417C2.78517 6.12121 2.36305 6.53984 2.14162 7.06803C1.92019 7.59622 1.91757 8.19072 2.13435 8.72083Z" fill="currentColor" fillOpacity="0.5"></path>
        </svg>
    )
}

export default IconPlusSquare
